import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "dashboard-area company-dashboard pt-120 mb-120" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-12" }
const _hoisted_5 = { class: "my-profile-inner" }
const _hoisted_6 = { class: "form-wrapper" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "section-title two" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "Update Job"),
  /*#__PURE__*/_createElementVNode("div", { class: "dash" })
], -1)
const _hoisted_8 = { class: "profile-form" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "section-title2" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "Job Information:")
], -1)
const _hoisted_10 = {
  key: 0,
  class: "row"
}
const _hoisted_11 = { class: "col-md-6" }
const _hoisted_12 = { class: "form-inner mb-25" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { for: "job_title" }, "Job Title*", -1)
const _hoisted_14 = { class: "input-area" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/company-2.svg",
  alt: ""
}, null, -1)
const _hoisted_16 = ["disabled"]
const _hoisted_17 = { class: "col-md-6" }
const _hoisted_18 = { class: "form-inner mb-25" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", null, "Job Type*", -1)
const _hoisted_20 = { class: "input-area" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/category-2.svg",
  alt: ""
}, null, -1)
const _hoisted_22 = { class: "col-md-6" }
const _hoisted_23 = { class: "form-inner mb-25" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", null, "Working Mode*", -1)
const _hoisted_25 = { class: "input-area" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/category-2.svg",
  alt: ""
}, null, -1)
const _hoisted_27 = { class: "col-md-6" }
const _hoisted_28 = { class: "form-inner mb-25" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", null, "Payment Mode*", -1)
const _hoisted_30 = { class: "input-area" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/category-2.svg",
  alt: ""
}, null, -1)
const _hoisted_32 = { class: "col-md-6" }
const _hoisted_33 = { class: "form-inner mb-25" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", null, "Qualification *", -1)
const _hoisted_35 = { class: "input-area" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/qualification-2.svg",
  alt: ""
}, null, -1)
const _hoisted_37 = ["disabled"]
const _hoisted_38 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select Qualification", -1)
const _hoisted_39 = ["label"]
const _hoisted_40 = ["value", "selected"]
const _hoisted_41 = { class: "col-md-6" }
const _hoisted_42 = { class: "form-inner mb-25" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("label", null, "Gender Required", -1)
const _hoisted_44 = { class: "input-area" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/category-2.svg",
  alt: ""
}, null, -1)
const _hoisted_46 = { class: "col-md-6" }
const _hoisted_47 = { class: "form-inner mb-25" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("label", null, "Job Category", -1)
const _hoisted_49 = { class: "input-area" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/category-2.svg",
  alt: ""
}, null, -1)
const _hoisted_51 = ["disabled"]
const _hoisted_52 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select Job Category", -1)
const _hoisted_53 = ["value"]
const _hoisted_54 = { class: "col-md-12" }
const _hoisted_55 = { class: "form-inner mb-25" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("label", { for: "description" }, "Job Description*", -1)
const _hoisted_57 = ["disabled"]
const _hoisted_58 = { class: "col-md-12" }
const _hoisted_59 = { class: "form-inner mb-25" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("label", { for: "description" }, "Job Responsibilities*", -1)
const _hoisted_61 = ["disabled"]
const _hoisted_62 = { class: "col-md-3" }
const _hoisted_63 = { class: "form-inner mb-25" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("label", { for: "vacancy" }, "Vacancies", -1)
const _hoisted_65 = { class: "input-area" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/company-2.svg",
  alt: ""
}, null, -1)
const _hoisted_67 = ["disabled"]
const _hoisted_68 = { class: "col-md-3" }
const _hoisted_69 = { class: "form-inner mb-25" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("label", { for: "experience" }, "Experience (Years)", -1)
const _hoisted_71 = { class: "input-area" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/company-2.svg",
  alt: ""
}, null, -1)
const _hoisted_73 = ["disabled"]
const _hoisted_74 = { class: "col-md-3" }
const _hoisted_75 = { class: "form-inner mb-25" }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("label", { for: "salary_from" }, "Salary (from)", -1)
const _hoisted_77 = { class: "input-area" }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/company-2.svg",
  alt: ""
}, null, -1)
const _hoisted_79 = ["disabled"]
const _hoisted_80 = { class: "col-md-3" }
const _hoisted_81 = { class: "form-inner mb-25" }
const _hoisted_82 = /*#__PURE__*/_createElementVNode("label", { for: "salary_from" }, "Salary (to)", -1)
const _hoisted_83 = { class: "input-area" }
const _hoisted_84 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/company-2.svg",
  alt: ""
}, null, -1)
const _hoisted_85 = ["disabled"]
const _hoisted_86 = { class: "col-md-6" }
const _hoisted_87 = { class: "form-inner mb-25" }
const _hoisted_88 = /*#__PURE__*/_createElementVNode("label", { for: "salary_from" }, "Job Expiry", -1)
const _hoisted_89 = { class: "input-area" }
const _hoisted_90 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/company-2.svg",
  alt: ""
}, null, -1)
const _hoisted_91 = { class: "col-md-12" }
const _hoisted_92 = { class: "form-inner" }
const _hoisted_93 = {
  key: 1,
  class: "primry-btn-2 lg-btn w-unset",
  type: "button",
  disabled: ""
}
const _hoisted_94 = /*#__PURE__*/_createElementVNode("span", { class: "me-3 fs-6 text-white" }, "Processing...", -1)
const _hoisted_95 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-spinner fa-spin text-white ms-3",
  style: {"font-size":"24px"}
}, null, -1)
const _hoisted_96 = [
  _hoisted_94,
  _hoisted_95
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_company_menu = _resolveComponent("company-menu")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Calendar = _resolveComponent("Calendar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_company_menu),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("form", _hoisted_8, [
                _hoisted_9,
                (_ctx.company)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _hoisted_13,
                          _createElementVNode("div", _hoisted_14, [
                            _hoisted_15,
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.jobForm.job_title) = $event)),
                              type: "text",
                              id: "job_title",
                              name: "job_title",
                              disabled: !_ctx.editTitle
                            }, null, 8, _hoisted_16), [
                              [_vModelText, _ctx.jobForm.job_title]
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _hoisted_19,
                          _createElementVNode("div", _hoisted_20, [
                            _hoisted_21,
                            _createVNode(_component_Dropdown, {
                              onChange: _ctx.changeJobType,
                              modelValue: this.jobForm.job_type_id,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((this.jobForm.job_type_id) = $event)),
                              options: _ctx.jobTypes,
                              placeholder: "Select Job Type",
                              ref: "language",
                              optionLabel: "name",
                              optionValue: "id",
                              disabled: !_ctx.editTitle,
                              class: "w-full md:w-14rem"
                            }, null, 8, ["onChange", "modelValue", "options", "disabled"])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, [
                          _hoisted_24,
                          _createElementVNode("div", _hoisted_25, [
                            _hoisted_26,
                            _createVNode(_component_Dropdown, {
                              onChange: _ctx.changeWorkingMode,
                              modelValue: this.jobForm.working_mode,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((this.jobForm.working_mode) = $event)),
                              options: _ctx.working_modes,
                              ref: "language",
                              placeholder: "Select Working Mode",
                              optionLabel: "name",
                              optionValue: "id",
                              disabled: !_ctx.editTitle,
                              class: "w-full md:w-14rem"
                            }, null, 8, ["onChange", "modelValue", "options", "disabled"])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, [
                          _hoisted_29,
                          _createElementVNode("div", _hoisted_30, [
                            _hoisted_31,
                            _createVNode(_component_Dropdown, {
                              onChange: _ctx.changePaymentMode,
                              modelValue: this.jobForm.payment_mode,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((this.jobForm.payment_mode) = $event)),
                              options: _ctx.payment_modes,
                              ref: "language",
                              placeholder: "Select Payment Mode",
                              optionLabel: "name",
                              optionValue: "id",
                              disabled: !_ctx.editTitle,
                              class: "w-full md:w-14rem"
                            }, null, 8, ["onChange", "modelValue", "options", "disabled"])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("div", _hoisted_33, [
                          _hoisted_34,
                          _createElementVNode("div", _hoisted_35, [
                            _hoisted_36,
                            _withDirectives(_createElementVNode("select", {
                              class: "form-select",
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.jobForm.qualification_id) = $event)),
                              onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.changeQualification && _ctx.changeQualification(...args))),
                              disabled: !_ctx.editTitle
                            }, [
                              _hoisted_38,
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.qualifications, (group, index) => {
                                return (_openBlock(), _createElementBlock("optgroup", { label: index }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group, (item) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      value: item.id,
                                      selected: _ctx.jobForm.qualification_id == item.id
                                    }, _toDisplayString(item.name), 9, _hoisted_40))
                                  }), 256))
                                ], 8, _hoisted_39))
                              }), 256))
                            ], 40, _hoisted_37), [
                              [_vModelSelect, _ctx.jobForm.qualification_id]
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_41, [
                        _createElementVNode("div", _hoisted_42, [
                          _hoisted_43,
                          _createElementVNode("div", _hoisted_44, [
                            _hoisted_45,
                            _createVNode(_component_Dropdown, {
                              onChange: _ctx.changeGender,
                              modelValue: this.jobForm.gender,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((this.jobForm.gender) = $event)),
                              options: _ctx.genders,
                              ref: "language",
                              placeholder: "Select Gender",
                              optionLabel: "name",
                              optionValue: "id",
                              disabled: !_ctx.editTitle,
                              class: "w-full md:w-14rem"
                            }, null, 8, ["onChange", "modelValue", "options", "disabled"])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_46, [
                        _createElementVNode("div", _hoisted_47, [
                          _hoisted_48,
                          _createElementVNode("div", _hoisted_49, [
                            _hoisted_50,
                            _withDirectives(_createElementVNode("select", {
                              class: "form-select me-1",
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((this.jobForm.category_id) = $event)),
                              onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.changeCategory && _ctx.changeCategory(...args))),
                              disabled: !_ctx.editCategory
                            }, [
                              _hoisted_52,
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (category) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  value: category.id
                                }, _toDisplayString(category.name), 9, _hoisted_53))
                              }), 256))
                            ], 40, _hoisted_51), [
                              [_vModelSelect, this.jobForm.category_id]
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_54, [
                        _createElementVNode("div", _hoisted_55, [
                          _hoisted_56,
                          _withDirectives(_createElementVNode("textarea", {
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.jobForm.job_description) = $event)),
                            id: "description",
                            disabled: !_ctx.editBody,
                            placeholder: "Job Description"
                          }, null, 8, _hoisted_57), [
                            [_vModelText, _ctx.jobForm.job_description]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_58, [
                        _createElementVNode("div", _hoisted_59, [
                          _hoisted_60,
                          _withDirectives(_createElementVNode("textarea", {
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.jobForm.job_responsibilities) = $event)),
                            disabled: !_ctx.editBody,
                            placeholder: "Job Responsibilities"
                          }, null, 8, _hoisted_61), [
                            [_vModelText, _ctx.jobForm.job_responsibilities]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_62, [
                        _createElementVNode("div", _hoisted_63, [
                          _hoisted_64,
                          _createElementVNode("div", _hoisted_65, [
                            _hoisted_66,
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.jobForm.vacancy) = $event)),
                              type: "text",
                              disabled: !_ctx.editBody,
                              id: "vacancy",
                              name: "companyname",
                              placeholder: "Number of vacancies"
                            }, null, 8, _hoisted_67), [
                              [_vModelText, _ctx.jobForm.vacancy]
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_68, [
                        _createElementVNode("div", _hoisted_69, [
                          _hoisted_70,
                          _createElementVNode("div", _hoisted_71, [
                            _hoisted_72,
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.jobForm.experience) = $event)),
                              type: "text",
                              id: "experience",
                              disabled: !_ctx.editBody,
                              name: "experience",
                              placeholder: "1 year"
                            }, null, 8, _hoisted_73), [
                              [_vModelText, _ctx.jobForm.experience]
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_74, [
                        _createElementVNode("div", _hoisted_75, [
                          _hoisted_76,
                          _createElementVNode("div", _hoisted_77, [
                            _hoisted_78,
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.jobForm.salary_from) = $event)),
                              type: "text",
                              disabled: !_ctx.editBody,
                              id: "salary_from",
                              name: "salary_from",
                              placeholder: "Salary from"
                            }, null, 8, _hoisted_79), [
                              [_vModelText, _ctx.jobForm.salary_from]
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_80, [
                        _createElementVNode("div", _hoisted_81, [
                          _hoisted_82,
                          _createElementVNode("div", _hoisted_83, [
                            _hoisted_84,
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.jobForm.salary_to) = $event)),
                              type: "text",
                              disabled: !_ctx.editBody,
                              id: "salary_to",
                              name: "salary_to",
                              placeholder: "Salary to"
                            }, null, 8, _hoisted_85), [
                              [_vModelText, _ctx.jobForm.salary_to]
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_86, [
                        _createElementVNode("div", _hoisted_87, [
                          _hoisted_88,
                          _createElementVNode("div", _hoisted_89, [
                            _hoisted_90,
                            _createVNode(_component_Calendar, {
                              modelValue: _ctx.jobForm.expiration,
                              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.jobForm.expiration) = $event)),
                              dateFormat: "dd/mm/yy",
                              disabled: !_ctx.editBody
                            }, null, 8, ["modelValue", "disabled"])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_91, [
                        _createElementVNode("div", _hoisted_92, [
                          (!_ctx.isLoading)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.updateJob && _ctx.updateJob(...args))),
                                class: "primry-btn-2 lg-btn w-unset",
                                type: "button"
                              }, "Update Job"))
                            : (_openBlock(), _createElementBlock("button", _hoisted_93, _hoisted_96))
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}